export const SpamCategories = {
  Coordinate: 1,
  // Item: 2,
  // Set: 3,
  User: 4,
  // Shop: 5,
  // Brand: 6,
  // Recommend: 7,
  // Diary: 8,
  Folder: 9,
  Video: 10,
} as const

export type SpamCategories =
  (typeof SpamCategories)[keyof typeof SpamCategories]
